import { EnumValues } from '@/services/types/EnumValues';

// Mirrors the backend's ScheduledPaymentIntervalType (@JsonValue - lowercase on the wire),
// reused as-is by ScheduledWalletTransferController (see RqCreateScheduledWalletTransfer.kt /
// ScheduledPaymentIntervalType.kt in EmergeFrontService).
export const ScheduledWalletTransferIntervalEnum = {
  ONE_OFF: 'one_off',
  EVERY_NUMBER_OF_DAYS: 'every_number_of_days',
  EVERY_MONTH_ON_DAY: 'every_month_on_day',
  LAST_DAY_OF_MONTH: 'last_day_of_month'
} as const;
export type ScheduledWalletTransferIntervalEnum = EnumValues<
  typeof ScheduledWalletTransferIntervalEnum
>;

// Mirrors the backend's ScheduledWalletTransferState.
export const ScheduledWalletTransferStateEnum = {
  SCHEDULED: 'scheduled',
  FAILED: 'failed',
  COMPLETED: 'completed'
} as const;
export type ScheduledWalletTransferStateEnum = EnumValues<typeof ScheduledWalletTransferStateEnum>;

// Maps to Kotlin RqCreateScheduledWalletTransfer (POST api/v1/scheduled-transfers).
export type TRqCreateScheduledWalletTransfer = {
  fromWalletId: string;
  toWalletId: string;
  amount: number;
  transferDate: string; // ISO 8601 ZonedDateTime, e.g. yyyy-MM-dd'T'HH:mm:ss.SSSZ
  paymentIntervalType: ScheduledWalletTransferIntervalEnum;
  paymentIntervalValue?: number;
  note?: string;
};

// Maps to Kotlin RsScheduledWalletTransfer.
export type TRsScheduledWalletTransfer = {
  id: string;
  customerId: string;
  fromWalletId: string;
  toWalletId: string;
  amount: number;
  nextTransferDate: string;
  paymentIntervalType: ScheduledWalletTransferIntervalEnum;
  paymentIntervalValue?: number;
  state: ScheduledWalletTransferStateEnum;
  isActive: boolean;
  note?: string;
  createdAt: string;
};
